import {fork} from 'redux-saga/effects';
import errorFlow from './common/redux/sagas.errors';
import authFlow from './auth/redux/sagas';
import forgotPasswordFlow from './auth/redux/sagas.forgotPw';
import checkinFlow from './checkins/redux/sagas';
import profileFlow from './profile/redux/sagas';
import signupFlow from './auth/redux/sagas.signup';
import publicProfileFlow from './publicUser/redux/sagas';

export default function* root() {
  yield [
    fork(errorFlow),
    fork(authFlow),
    fork(forgotPasswordFlow),
    fork(checkinFlow),
    fork(profileFlow),
    fork(signupFlow),
    fork(publicProfileFlow)
  ];
}



// WEBPACK FOOTER //
// ./shared/sagas.js